import { render, staticRenderFns } from "./Resume.vue?vue&type=template&id=f8fa039c"
import script from "./Resume.vue?vue&type=script&lang=js"
export * from "./Resume.vue?vue&type=script&lang=js"
import style0 from "./Resume.vue?vue&type=style&index=0&id=f8fa039c&prod&lang=css"
import style1 from "./Resume.vue?vue&type=style&index=1&id=f8fa039c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports